<template>
  <BbPopup v-model="popupOpened" :showCloseIcon="true" contentClass="prompt-card-preview">
    <template #popup-header>
      <TextBody tag="span" i18n-key="assist.promptCardPreview" :body-type="3" weight="medium" />
    </template>
    <TextBody :text="title" tag="div" :body-type="2" weight="medium" className="title" />
    <TipTapEditor v-if="templateContent" v-model="templateContent" :dataContent="dataContent" :disabled="true" />
    <template #popup-actions>
      <BbBtn type="secondary" @click="onSelectPrompt" :is-disabled="inputsDisabled">
        <TextBody i18n-key="assist.promptAgain" />
      </BbBtn>
      <BbBtn color="#6222E3" @click="popupOpened = false">
        <TextBody i18n-key="common.done" />
      </BbBtn>
    </template>
  </BbPopup>
</template>

<script>
import { computed, toRaw, watch, ref } from 'vue';
import { useStore } from 'vuex';

import { GetUserData } from '~/constants/getters';

import TextBody from '~/components/common/TextBody.vue';
import useQuickPrompts from '~/composables/useQuickPrompts';
import useFormFilters from '~/composables/useFormFilters';
import TipTapEditor from '~/components/tiptap/index.vue';
import useConversations from '~/composables/useConversations';

export default {
  components: { TipTapEditor, TextBody },
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
      default: '',
    },
    versionContentId: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: '',
    },
    promptCardVariables: {
      type: Array,
      default: () => [],
    },
    filters: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const store = useStore();
    const { currentConversation } = useConversations();
    const { getPromptCardByVersionId, setDisplayPromptsInNewTab, setInitialFieldsAndPromptCard } = useQuickPrompts();
    const { setFiltersObject } = useFormFilters();

    const popupOpened = computed({
      get: () => props.opened,
      set: (val) => emit('update:open', val),
    });

    const userData = computed(() => store.getters[`authStore/${GetUserData}`]);
    const inputsDisabled = computed(
      () => !!(currentConversation.value?.userId && currentConversation.value?.userId !== userData.value?.id),
    );

    const templateContent = ref('');
    const dataContent = ref([]);
    const variables = ref([]);
    const promptData = ref(null);

    const handlePrompt = async () => {
      setDisplayPromptsInNewTab(false);
      setTimeout(() => {
        const filtersObj = Object.fromEntries((props.filters || [])?.map((item) => [item.key, toRaw(item.value)]));
        setFiltersObject({ document: filtersObj || {} });
        setInitialFieldsAndPromptCard({ variables: variables.value, promptData: promptData.value });
        popupOpened.value = false;
        setDisplayPromptsInNewTab(true);
      }, 10);
    };

    watch(
      () => props.opened,
      async (newVal) => {
        if (newVal) {
          const result = await getPromptCardByVersionId({
            id: props.versionContentId,
            variablesToFill: props.promptCardVariables,
            isInputDisabled: true,
          });

          if (result) {
            templateContent.value = result.promptData?.template || '';
            dataContent.value = result.promptData?.data || [];
            variables.value = result.variables || [];
            promptData.value = result.promptData || null;
          }
        }
      },
    );

    return {
      popupOpened,
      onSelectPrompt: handlePrompt,
      templateContent,
      dataContent,
      inputsDisabled,
    };
  },
};
</script>
